export default __webpack_public_path__ + "static/media/img-video-3.42366f37.png";